import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getIsReadOnlyAdminUser } from '../../../auth/selectors';

const AdminActionButton = props => (
  <button
    {...props}
    disabled={props.disabled}
  >
    {props.children}
  </button>
);

AdminActionButton.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool.isRequired,
};

AdminActionButton.defaultProps = {
  children: null,
};

export default connect((state, ownProps) => ({
  disabled: ownProps.disabled || getIsReadOnlyAdminUser(state),
}))(AdminActionButton);
